import React from 'react';
import { useDarkMode } from '../darkmode/DarkModeContext';

const BannerUpggrade = () => {
  const { isDarkMode } = useDarkMode();

  return (
    <section
      className="relative py-16 bg-cover bg-center transition-colors duration-300"
      style={{
        backgroundImage: "url('https://telnet.net.id/assets/bg.png')",
        backgroundColor: isDarkMode ? '#111827' : '#dfe4e0ff',
        backgroundBlendMode: 'overlay',
      }}
    >
      {/* Overlay agar kontras nyaman di light/dark */}
      <div
        className={`absolute inset-0 pointer-events-none ${
          isDarkMode
            ? 'bg-gradient-to-r from-black/60 via-[#1E9B4C]/20 to-black/60'
            : 'bg-gradient-to-r from-white/50 via-[#1E9B4C]/15 to-white/50'
        }`}
      />

      <div className="relative max-w-4xl mx-auto px-4 text-center">
        <h2 className={`text-4xl font-bold mb-6 ${isDarkMode ? 'text-green-50' : 'text-gray-900'}`}>
          Siap Upgrade Internet Anda?
        </h2>

        <p className={`text-xl mb-8 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
          Bergabung dengan ribuan pelanggan yang telah merasakan kecepatan internet fiber terdepan di Aceh
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
          <button
            className={`
              px-8 py-4 rounded-full font-bold text-lg transition-colors
              ${isDarkMode
                ? 'bg-[#1E9B4C] text-green-50 hover:bg-emerald-600'
                : 'bg-[#1E9B4C] text-white hover:bg-green-700'}
            `}
          >
            Konsultasi Gratis
          </button>
          <button
            className={`
              px-8 py-4 rounded-full font-bold text-lg border-2 transition-colors
              ${isDarkMode
                ? 'border-green-200 text-green-100 hover:bg-green-50 hover:text-green-700'
                : 'border-[#1E9B4C] text-[#1E9B4C] hover:bg-[#1E9B4C] hover:text-white'}
            `}
          >
            Hubungi Sales
          </button>
        </div>

        {/* Metrics */}
        <div className="grid md:grid-cols-3 gap-6 text-center">
          <div>
            <div className={`${isDarkMode ? 'text-green-50' : 'text-gray-900'} text-3xl font-bold`}>1000+</div>
            <div className={`${isDarkMode ? 'text-emerald-300' : 'text-[#1E9B4C]'}`}>Pelanggan Aktif</div>
          </div>
          <div>
            <div className={`${isDarkMode ? 'text-green-50' : 'text-gray-900'} text-3xl font-bold`}>99.9%</div>
            <div className={`${isDarkMode ? 'text-emerald-300' : 'text-[#1E9B4C]'}`}>Customer Satisfaction</div>
          </div>
          <div>
            <div className={`${isDarkMode ? 'text-green-50' : 'text-gray-900'} text-3xl font-bold`}>24/7</div>
            <div className={`${isDarkMode ? 'text-emerald-300' : 'text-[#1E9B4C]'}`}>Technical Support</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerUpggrade;